import { withStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";

const styles = {
  circularProgress: {
    position: "fixed",
    top: "calc(50% - 12.5px)",
    left: "calc(50% - 12.5px)",
  },
};

function Loading(props) {
  const { classes } = props;
  return (
    <div className={classes.circularProgress}>
      <CircularProgress color="black" size={25} />
    </div>
  );
}

export default withStyles(styles)(Loading);
